import React from 'react';

const PRIVACY_TEXT = `Last updated: May 2026

1. Information We Collect

We collect information you provide directly to us when you create an account, upload leads, or contact us for support. This includes your name, email address, company name, and any lead data you choose to enter.

We automatically collect certain usage information when you use the service, including log data (IP address, browser type, pages visited, time spent), and device information.

2. How We Use Your Information

We use the information we collect to:
• Provide, maintain, and improve the service
• Score and analyze your sales leads using AI
• Send you daily digest emails and account notifications
• Respond to your support requests
• Enforce our Terms of Service and protect against misuse

3. Data Sharing

We do not sell your personal information. We share data only with:
• Service providers who help us operate the platform (hosting, email delivery, AI analysis)
• Law enforcement when required by law or to protect our rights

4. Data Retention

We retain your account data for as long as your account is active or as needed to provide the service. Lead data is retained until you delete it or close your account. You may export or delete your data at any time from the Settings page.

5. Security

We use industry-standard encryption (AES-256-GCM) for sensitive credentials stored in our database. Data in transit is encrypted via TLS. No method of transmission over the internet is 100% secure, and we cannot guarantee absolute security.

6. Your Rights

You may request access to, correction of, or deletion of your personal data by contacting us at support@lead-scoring-saas.com. We will respond within 30 days.

7. Cookies

We use a single session cookie to keep you logged in. We do not use tracking cookies or third-party advertising cookies.

8. Changes to This Policy

We may update this Privacy Policy from time to time. We will notify you of material changes by posting the new policy on this page with an updated date.

9. Contact Us

If you have questions about this Privacy Policy, please contact us at support@lead-scoring-saas.com.`;

export default function Privacy() {
    return (
        <div className="max-w-3xl mx-auto px-4 py-10">
            <h1 className="text-3xl font-bold text-gray-900 mb-2">Privacy Policy</h1>
            <div className="prose prose-gray max-w-none mt-6">
                {PRIVACY_TEXT.split('\n\n').map((block, i) => {
                    if (/^\d+\./.test(block.trim())) {
                        const [heading, ...rest] = block.split('\n');
                        return (
                            <div key={i} className="mb-6">
                                <h2 className="text-lg font-semibold text-gray-800 mb-2">{heading}</h2>
                                {rest.length > 0 && (
                                    <p className="text-gray-600 leading-relaxed whitespace-pre-line">{rest.join('\n')}</p>
                                )}
                            </div>
                        );
                    }
                    return (
                        <p key={i} className="text-gray-600 leading-relaxed mb-4 whitespace-pre-line">
                            {block}
                        </p>
                    );
                })}
            </div>
        </div>
    );
}
